//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransitionExpand from "../transitions/TransitionExpand";
import SearchFiltersItem from "./SearchFiltersItem";

export default {
  name: "SearchFiltersGroup",
  props: ["filterGroup"],
  components: {
    TransitionExpand,
    SearchFiltersItem,
  },
  data() {
    return {
      active: true,
    };
  },
};
